import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { NavLink , useNavigate, useParams} from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';

const ViewExhibition = ()=> {

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const [artworkData, setArtworkData] = useState([]);
    const [exhibitionData, setExhibitionData] = useState({
        exhibitionTitle: '', exhibitionDate: '', description: ''
    });

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionDetailsToEditByID?id=${id}`, setExhibitionData);
            fetchData(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionArtworkToViewByExhibitionID?exhibitionID=${id}`, setArtworkData);
        }
    }, [id]);


    const columns = [
        {
            cell: (row) => {
                return (
                    <div className="pd_item" key={row.id}>
                        <div className="img_box">
                            <img src={`../../../images/products/thumbnail/${row.imageURL}`} className="pd_img" alt="" />
                        </div>
                        <div className="pd_content">
                            <span className="pd_brand">{row.productTitle}</span>
                            
                            <span className="pd_title">Art by:
                            <span className="btn_artist1">
                                    {row.artistName}
                                </span>
                            </span>                            
                            <span className="pd_title">Status : {row.statusName}</span>
                            <a className="btn3" onClick={() => handleRemoveFromExhibition(row.productID)}>Remove from Exhibition</a>
                        </div>
                    </div>
                );
            }
        },
    ]; 

    const paginationComponentOptions = {
        noRowsPerPage: true
    };
    
    const handleRemoveFromExhibition = async(productId) => {

        const confirmed = window.confirm("Are you sure you want to Remove artwork from Exhibition ?");
        
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        const formData = {
            "exhibitionID":id,
            "productID": productId,
            "createdBy": userInfo.user_id
        };
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/ExhibitionList/AddRemove-AddRemoveTDExhibitionArtwork`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData), // Replace with your data
            });
            if (response.ok) {
                
                toast.info('Artwork Removed from Exhibition !');
                fetchData(`https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionArtworkToViewByExhibitionID?exhibitionID=${id}`, setArtworkData);
            } else {
                // Server responded with an HTTP status code outside the range 200-299
                console.error('Failed to delete cart item. Status:', response.status);
            }
            
        }
        catch (error) {
            console.error('Error saving form data:', error);
        }
    };

    return(
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <PageHeader name='Exhibition' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Exhibition Details</div>
                                    <div className="card-body">
                                    <NavLink className="btn btn-primary float-end" to={'/exhibition'}  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                    <NavLink className="btn btn-primary float-end me-2" to={`/addExhibitionArtwork/${id}`}  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> Add More Artwork</NavLink>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="col-sm-6 form-group mb-3">
                                                    <h5>
                                                        <label style={{ marginRight: '10px' }}>Exhibition Title : </label>
                                                        <label>{exhibitionData.exhibitionTitle}</label>  
                                                    </h5>
                                                </div>
                                                <div className="col-sm-6 form-group mb-3">
                                                    <h5>
                                                        <label style={{ marginRight: '10px' }}>Exhibition Date : </label>
                                                        <label> {exhibitionData.exhibitionDate}</label>  
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="col-sm-12 form-group mb-3">
                                                    <h5>
                                                        <label style={{ marginRight: '10px' }}>Exhibition Write-up : </label>
                                                        <span dangerouslySetInnerHTML={{ __html: exhibitionData.description }} />
                                                    </h5>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-12 pd-list">
                                            <DataTable
                                                columns={columns}
                                                data={artworkData}
                                                pagination
                                                noTableHead
                                                paginationComponentOptions={paginationComponentOptions}
                                                paginationPerPage={[20]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                        <ToastContainer position="bottom-right" />
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )

};
export default ViewExhibition;